module.exports = __webpack_public_path__ + "img/cs-top-image.1728b009.svg";